import React, {Component} from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from "../../components/Skeleton/Skeleton";
import {connect} from "react-redux";
import {REQUEST_NEWS_DATA} from "../../actions/newsActions";
import ContentPage from "../../components/ContentPage/ContentPage";


const mapStateToProps = state => {
  return {
    newsData: state.newsData
  }
};

const mapDispatchToProps = dispatch => ({
  getNewsData: () => dispatch({type: REQUEST_NEWS_DATA})
});


class NewsItem extends Component {
  
  componentDidMount() {
    if (!Object.keys(this.props.newsData).length) {
      this.props.getNewsData();
    }
  };
  
  render() {
    return (
      <div className="wrapper">
        <Breadcrumbs/>
        {
          Object.keys(this.props.newsData).length ? (
            <ContentPage
              content={this.props.newsData}
              arrayName="news"
              redirectPath="/about/news"
            />
          ) : <Skeleton type="IFRAME"/>
        }
      </div>
    )
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(NewsItem));



// WEBPACK FOOTER //
// ./src/pages/About/NewsItem.js